import { render, staticRenderFns } from "./RegularModePanel.vue?vue&type=template&id=6f20289e&scoped=true"
import script from "./RegularModePanel.vue?vue&type=script&lang=js"
export * from "./RegularModePanel.vue?vue&type=script&lang=js"
import style0 from "./RegularModePanel.vue?vue&type=style&index=0&id=6f20289e&prod&lang=scss&scoped=true"
import style1 from "./RegularModePanel.vue?vue&type=style&index=1&id=6f20289e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f20289e",
  null
  
)

export default component.exports